import $ from 'jquery';
import 'bootstrap/js/dist/modal';
import axios from "axios";
import {makeAuthFormData} from "../general-form-maker";
import {renderErrorByResponse} from '../render-response';
import {renderSignUpSuccessModal} from "../info/render-sign-up-success-modal";
import {registrationHandler} from "../../dataLayer/data-layer-metrica-handlers";
import {getReCaptchaToken} from "Core/recaptcha";

export const bindEventsToModalSignUp = () => {
    $('.signup-button').click(function () {
        eventsModalSignUp($(this).parents('.sign-up-parent'), getReCaptchaToken($(this)));
    });

    $(".sign-up-parent input").keyup(function (event) {
        if (event.keyCode === 13) {
            eventsModalSignUp($(this).parents('.sign-up-parent'), getReCaptchaToken($(this)));
        }
    });
};

const eventsModalSignUp = (parent, token) => {
    const url = parent.data('url');

    axios.post(url, makeAuthFormData(parent, token))
        .then((response) => {
            renderSignUpSuccessModal();
            registrationHandler();

            if (response.data.redirectUrl !== undefined) {
                const modal = $('#successful-login');

                modal.find('.modal-form__button').attr('href', response.data.redirectUrl);
                modal.attr('data-redirect-url', response.data.redirectUrl);
                window.location = response.data.redirectUrl;
            }
        })
        .catch((error) => {
            renderErrorByResponse(error.response, parent);
        });
};
